const RETRY_TIME_MS = 1000;
export const waitFor = async (callback: () => Promise<boolean>, retryTimeMs = RETRY_TIME_MS) => {
    while (!(await callback())) {
        await new Promise((resolve) => setTimeout(resolve, retryTimeMs));
    }
};
